"use strict";

import Hammer from 'hammerjs';

import {breakpointUp, breakpointDown} from './breakpoints';

export default class SliderNav {

    constructor (slider) {
        this.index = 0;
        this.slider = slider;
        this.holder = slider.querySelector('.holder');
        this.slideCount = slider.querySelectorAll('.slider-item').length - 1;

        const sliderId = this.slider.dataset.slider;
        this.sliderNav = document.querySelector(`.slide-nav[data-slider="${sliderId}"]`);
        this.countHolder = this.sliderNav.querySelector('.count');


        this.setupTouch();
        this.setup();
        window.addEventListener('resize', () => {
            this.setup();
        });
    }

    get allButtonsVisible () {
        return breakpointDown('md') || (breakpointUp('lg') && breakpointDown('xxl'));
    }

    get totalSlides () {
        return (this.slideCount + 1) / (this.allButtonsVisible ? 1 : 2);
    }

    get currentSlide () {
        return Math.ceil((this.index + 1) / (this.allButtonsVisible ? 1 : 2));
    }

    setup () {
        this.slideWidth = this.slider.querySelector('.slider-item').offsetWidth;
        this.slidesVisible = 2;

        if ( this.allButtonsVisible ) {
            this.slidesVisible = 1;
        }

        this.setupSlideButtons();
        this.slider.style.height = this.holder.offsetHeight +'px';
        //document.querySelector('.dit-doen-wij-holder').style.height = this.holder.offsetHeight + 80 +'px';
    }

    setupSlideButtons () {
        this.sliderNav.querySelectorAll('.btn').forEach(btn => btn.remove());

        for ( let index = 0; index <= this.slideCount / this.slidesVisible; index++ ) {
            const btn = document.createElement('button');
            btn.classList.add('btn', 'index');
            btn.dataset.index = index;
            btn.innerHTML = index;

            this.sliderNav.insertBefore(btn, this.sliderNav.querySelector('.btn.prev'));
        }

        this.sliderNavBtns = this.sliderNav.querySelectorAll(`.btn`);
        this.setupActiveButton();

        this.countHolder.dataset.current = this.currentSlide;
        this.countHolder.dataset.total = this.totalSlides;

        this.sliderNavBtns
            .forEach(btn =>
                btn.addEventListener('click',
                    () => this.handleSlideClick(btn)
                )
            );
    }

    setupTouch () {
        const hammerTime = new Hammer(this.holder);

        hammerTime.on("hammer.input", evt => evt.preventDefault());

        hammerTime.on('swipeleft', () => {
            if ( this.index <= this.slideCount - this.slidesVisible ) {
                this.incrementIndex();
                this.updateSlider();
            }
        });

        hammerTime.on('swiperight', () => {
            if ( this.index > 0 ) {
                this.decrementIndex();
                this.updateSlider();
            }
        });
    }

    setupActiveButton () {
        this.sliderNavBtns.forEach(btn => {
            if ( btn.dataset.index && parseInt(btn.dataset.index * this.slidesVisible) === this.index ) {
                btn.classList.add('current');
            } else {
                btn.classList.remove('current');
            }
        });
    }

    incrementIndex () {
        this.index += this.slidesVisible;
        if ( this.index > this.slideCount ) {
            this.index = 0;
        }
    }

    decrementIndex () {
        this.index -= this.slidesVisible;
        if ( this.index < 0 ) {
            this.index = this.slideCount;
        }
    }

    handleSlideClick (btn) {
        if ( btn.classList.contains('next') ) {
            this.incrementIndex();
        } else if ( btn.classList.contains('prev') ) {
            this.decrementIndex();
        } else if ( btn.dataset.index ) {
            this.index = parseInt(btn.dataset.index * this.slidesVisible);
        }

        this.updateSlider();
    }

    updateSlider () {
        this.holder.style.transform = `translateX(-${(this.slideWidth+40)*this.index+5}px`;

        this.countHolder.dataset.current = this.currentSlide;
        this.countHolder.dataset.total = this.totalSlides;

        this.setupActiveButton();
    }
}
